'use client';

import { usePathname } from 'next/navigation';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import KakaoButton from '@/components/KakaoButton';

// 관리자 화면에서는 공개 사이트 메뉴·푸터를 숨긴다
export default function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (pathname?.startsWith('/admin')) return <main className="min-h-screen">{children}</main>;

  return (
    <>
      <Navigation />
      <main className="min-h-screen">{children}</main>
      <Footer />
      <KakaoButton />
    </>
  );
}
